/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Project_Instructions_BlurbInputs */



/**
* | output |
* | --- |
* | "Project instructions shape how the assistant behaves in every chat in this project, including tone, expertise, and response format. They are prepended to eac..." |
*
* @param {Uno_Edu_Project_Instructions_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_project_instructions_blurb = /** @type {((inputs?: Uno_Edu_Project_Instructions_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Project_Instructions_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektanweisungen prägen das Verhalten des Assistenten in jedem Chat dieses Projekts, einschließlich Ton, Expertise und Antwortformat. Sie werden jeder Konversation vorangestellt.")
	return /** @type {LocalizedString} */ ("Project instructions shape how the assistant behaves in every chat in this project, including tone, expertise, and response format. They are prepended to each conversation.")
});